import React, { useEffect } from 'react';
import { OutputContainer } from 'containers';
import { gtmTrackPage } from 'utils/GTM/GTMUtil';
import { gaPageTrackTags } from 'utils/GTM/GATags';

const OutPutPage = props => {
	useEffect(() => {
		gtmTrackPage(gaPageTrackTags.outputPage);
	}, []);
	return (
		<>
			<OutputContainer {...props} />
		</>
	);
};

export default OutPutPage;
